module.exports = __webpack_public_path__ + "img/texture_tile.f48a321a.jpg";